// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var TicketAssign$ReactHooksTemplate = require("./ticketAssign.res.js");

function TicketAssignView(props) {
  var activity = props.activity;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Ticket Assigned",
                              className: "text-sm font-semibold"
                            }),
                        JsxRuntime.jsx("div", {
                              children: TicketAssign$ReactHooksTemplate.assigner(activity),
                              className: "text-xs font-normal"
                            })
                      ],
                      className: "flex justify-between text-darkcharcoal"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        "Assigned To: ",
                        TicketAssign$ReactHooksTemplate.assignee(activity)
                      ],
                      className: "flex text-xs font-normal mt-2"
                    })
              ]
            });
}

var make = TicketAssignView;

exports.make = make;
/* react/jsx-runtime Not a pure module */
